// Déclaration des functions 
    import functionsFiltres from '@/functions/filter.js'
    import functionsTris from '@/functions/tris.js'
    import functionsDate from '@/functions/date.js'
    import functions from '@/functions/functions.js'
    import { stringify } from 'uuid';
    
    const jours_fr = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    const alphabetUpper = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const listeClasse = ['eco', 'aff', 'pre', 'cargo']

    let functionsSpe = {
        ajouterHRSousDernierMot(text) {
            const words = text.split(' ');
            const lastWord = words.pop(); // On prend le dernier mot
            return `${words.join(' ')} <span class="last-word-hr">${lastWord}</span>`; 
        }
    }

    export default functionsSpe


// WEBPACK FOOTER //
// ./src/functions/functions_specifiques.js